import Axios from "axios";
import { SET_INV_DAMAGE_EXPIRE_REPORT, UNSET_INV_DAMAGE_EXPIRE_REPORT } from "@/store/mutation-types";
import { getInvDamageExpireReport } from "@/store/api";

const state = { getInvDamageExpireReport: {} };

const getters = {
  getInvDamageExpireReport(state) {
    return state.getInvDamageExpireReport;
  },
};

const mutations = {
  [SET_INV_DAMAGE_EXPIRE_REPORT](state, data) {
    state.getInvDamageExpireReport = data;
  },
  [UNSET_INV_DAMAGE_EXPIRE_REPORT](state) {
    state.getInvDamageExpireReport = {};
  },
};

const actions = {
  getInvDamageExpireReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvDamageExpireReport, { params: data })
        .then(function (response) {
          commit("SET_INV_DAMAGE_EXPIRE_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_DAMAGE_EXPIRE_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
